define(function (require) {
	const Marionette = require('backbone.marionette');
	const Radio = require('backbone.radio');
	const LoginQuestionModel = require('civicsModels/login_question_model');
	const CodeDefinitionCollection = require('civicsCollections/code_definition_collection');
	const ViewManager = require('civicsUtils/view_manager');
	const tpl = require('./templates/t_itv_login_question.hbs');
	const Utils = require('civicsUtils/general_utilities');

	return Marionette.ItemView.extend({
		template: tpl,
		tagName: 'div',
		className: 'v_itv_question_item',
		modelEvents: {
			change: 'render'
		},
		events: {
			'click @ui.btnSubmit': 'submitClicked',
			'keyup @ui.inpAnswer': 'answerKeyPress',
			'click @ui.closeModalButton':'closeModal'
		},
		ui: {
			inpAnswer: '.answer .input-text',
			selQuestion: '.question .droppy-input',
			selQuestionBox: '.question',
			btnSubmit: '.btnSubmitQuestion',
			closeModalButton: '.bbm-btn-close'
		},
		initialize: function (options) {
			this.config = options.config;
			this.modalContainer = options.modalContainer;
			if (__DEV__) console.log('itvQuestion initialized');

			this.model = new LoginQuestionModel();

			// get codes
			var codes = new CodeDefinitionCollection();
			codes.moniker = 'Hansen.Resources.SecurityQuestion';
			codes.fetch()
				.done(_.bind(function (response, status, xhrResponse) {
					this.questionCodes = response.data.codeDescriptionItems;
					// note: render required because data not available when template is rendered
					this.render();
				}, this))
				.fail(function (response, status, xhrResponse) {
					ViewManager.errorToWindow(response);
				});
		},
		onRender: function () {
			this.$el.rhythmThemeInit();
			this.$el.rhythmCivicsTooltipInit();
		},

		closeModal:function(){
			this.modalContainer.hideModal();
		},
		answerKeyPress: function (e) {
			if (e.which === 13)	//enter keyCode
				this.submitClicked(e);
		},
		submitClicked: function (e) {
			e.preventDefault();
			var questionRaw = Utils.civicsDropdownValue(this.ui.selQuestionBox);
			var question = JSON.parse('{"code":"' + questionRaw + '"}');
			var answer = this.ui.inpAnswer.val();

			//answer is required.
			if (this.isEmpty(questionRaw)) {
				var error = {};
				error.validationError = {};
				error.validationError.question = i18n.t('CIVICS.COMMON.SECURITY_QUESTION_REQ_ERROR');
				ViewManager.errorToWindow(error, this);
			} else if(this.isEmpty(answer)) {
				ViewManager.resetErrorMessages(this);
				var error = {};
				error.validationError = {};
				error.validationError.answer = i18n.t('CIVICS.COMMON.ANSWER_REQ_ERROR');
				ViewManager.errorToWindow(error, this);
			} else {
				this.model.set('PasswordQuestion', question);
				this.model.set('PasswordAnswer', answer);
				this.model.save(null, {
					type: 'put',
					success: _.bind(function (model, response) {
						if (__DEV__) console.log('submitClicked success', model, response);
						if (response !== undefined) {
							this.config.loginChannel.command('finalize:Authentication');
						} else {
							$('.failureMessage').html(this.config.QuestionError);
						}
					}, this),
					error: _.bind(function (model, response) {
						if (__DEV__) console.log('submitClicked error', model, response);
						$('.failureMessage').html(this.config.QuestionError);
					}, this)
				});
			}
		},
		isEmpty: function (str) {
			return (!str || str.length === 0 || !str.trim());
		},
		templateHelpers: function () {
			return {
				questions: this.questionCodes,
			};
		}
	});
});
